module.exports = __webpack_public_path__ + "img/sesame.04ebbb91.png";